

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import Menu from '@/components/SideMenu/Menu.vue'

@Component({
  components: {
    Menu
  }
})
export default class SideMenu extends Vue {
  @Prop() room!: Room;
  @Prop() isGallary!: boolean;
  show = false;

  toggleSideMenu () {
    this.show = !this.show
  }

  closeSideMenu () {
    this.show = false
  }

  get self () {
    return this.room.self
  }

  get isNight () {
    if (this.room.game?.isFirstNight || this.room.game?.isNight) {
      return true
    }

    return false
  }
}
